export default {
  name: 'SelectEmployeeCustControl',
  components: {

  },
  props: {
    sourceCols: {
      type: Array,
      required: true
    },
    dataSource: { 
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      searchField: {},
      searchParameter: '',
      showWarning: false,
    }
  },
  watch: {
    searchField: function (val) {
      if (!val || !val.dataField)
        this.resetDialog();     

      this.$setFocusToElement('searchDialogInput');
    },
  },
  mounted() {
    this.searchField = this.sourceCols[0];
    this.$setFocusToElement('searchDialogInput', false, 1000);
  },
  methods: {
    search() {
      let results =
        this.dataSource.filter(d =>
          d[this.searchField.dataField] != null
            ? this.normalizeString(d[this.searchField.dataField])
              .includes(this.normalizeString(this.searchParameter))
            : false);

      if (results.length == 0)
        this.showWarning = true;
      else
        this.close(results);
    },
    normalizeString(item) {
      if (!item)
        return '';

      let it;
      if (typeof item != 'string')
        it = String(item);
      else
        it = item;

      return it.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    },
    resetDialog() {
      this.searchField = {};
      this.searchParameter = '';
      this.showWarning = false;
    },
    close(results) {
      this.resetDialog();
      this.$emit('close', results);
    }
  }
}

